module.exports = __webpack_public_path__ + "img/banner_pt.5481398a.jpg";